export default __webpack_public_path__ + "images/DH.8eb76ba.png";